/* יעדי תקציב לקטגוריה. יעד שנקבע בתקופה ממשיך לתקופות הבאות עד שמשנים אותו,
   כדי שלא צריך להזין את כל היעדים מחדש בכל חודש. סכום 0 שמור פירושו "בלי יעד מהתקופה הזו". */
import { S } from './state.js';

/** היעדים שחלים על תקופה: של התקופה עצמה, ואם אין, של התקופה האחרונה לפניה שהוגדרו בה */
export function budgetRows(k) {
  const months = [...new Set(S.budgets.map((g) => g.month))].filter((m) => m <= k).sort();
  const m = months[months.length - 1];
  return m ? S.budgets.filter((g) => g.month === m) : [];
}

/** רק יעדים פעילים (סכום חיובי) */
export function budgetsFor(k) {
  return budgetRows(k).filter((g) => Number(g.amount) > 0);
}
